// extracted by mini-css-extract-plugin
export default {"container":"Options_container__SeyF6","button":"Options_button__0eHiR","accent":"Options_accent__tvmkH","pressed":"Options_pressed__rxYxV"};